import {
  Display,
  PromoBannerV2,
  SpacingToken,
  Text,
} from '@livechat/design-system-react-components'
import { css } from '@emotion/react'
import { FeaturedCategory } from '../../constants/collections'

const bannerCss = (gradient?: string) => css`
  ${gradient && `background: ${gradient};`}

  .banner__content {
    padding: var(${SpacingToken.Spacing5});
    max-width: 100%;
  }

  p {
    margin-block: 0;
  }
`

const displayCss = css`
  margin-bottom: var(${SpacingToken.Spacing1});
`

const descriptionCss = css`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`

interface Props {
  category: FeaturedCategory
}

export const HeaderBanner = ({ category }: Props) => {
  const { label, description, gradient } = category

  return (
    <PromoBannerV2
      css={bannerCss(gradient)}
      contentClassName="banner__content "
    >
      <Display size="sm" css={displayCss}>
        {label}
      </Display>
      <Text css={descriptionCss}>{description}</Text>
    </PromoBannerV2>
  )
}
